import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckBox = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M28 9H12C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12V28C9 28.7956 9.31607 29.5587 9.87868 30.1213C10.4413 30.6839 11.2044 31 12 31H28C28.7956 31 29.5587 30.6839 30.1213 30.1213C30.6839 29.5587 31 28.7956 31 28V12C31 11.2044 30.6839 10.4413 30.1213 9.87868C29.5587 9.31607 28.7956 9 28 9ZM26.707 15.707L17.707 24.707C17.5195 24.8945 17.2652 24.9998 17 24.9998C16.7348 24.9998 16.4805 24.8945 16.293 24.707L13.293 21.707C13.1108 21.5184 13.01 21.2658 13.0123 21.0036C13.0146 20.7414 13.1198 20.4906 13.3052 20.3052C13.4906 20.1198 13.7414 20.0146 14.0036 20.0123C14.2658 20.01 14.5184 20.1108 14.707 20.293L17 22.586L25.293 14.293C25.3852 14.1975 25.4956 14.1213 25.6176 14.0689C25.7396 14.0165 25.8708 13.9889 26.0036 13.9877C26.1364 13.9866 26.2681 14.0119 26.391 14.0622C26.5138 14.1125 26.6255 14.1867 26.7194 14.2806C26.8133 14.3745 26.8875 14.4861 26.9378 14.609C26.9881 14.7319 27.0134 14.8636 27.0123 14.9964C27.0111 15.1292 26.9835 15.2604 26.9311 15.3824C26.8787 15.5044 26.8025 15.6148 26.707 15.707Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgCheckBox);
export default ForwardRef;
